import {
  BookOpen,
  Rocket,
  Plug,
  TrendingUp,
  HelpCircle,
  Zap,
  MessageCircleQuestion,
  DollarSign,
  type LucideIcon,
} from 'lucide-react';

export interface DocsNavItem {
  label: string;
  href: string;
  icon: LucideIcon;
  separator?: boolean;
}

export const docsNavigation: DocsNavItem[] = [
  { label: 'Guia de Producto', href: '/docs/product-guide', icon: BookOpen },
  { label: 'Implementacion', href: '/docs/implementation', icon: Rocket },
  { label: 'Integraciones', href: '/docs/integrations', icon: Plug },
  { label: 'ROI y Beneficios', href: '/docs/roi', icon: TrendingUp },
  { label: 'Estrategia de Pricing', href: '/docs/pricing-strategy', icon: DollarSign },
  { label: '', href: '', icon: BookOpen, separator: true },
  { label: 'Centro de Ayuda', href: '/docs/help', icon: HelpCircle },
  { label: 'Guia Rapida', href: '/docs/quick-start', icon: Zap },
  { label: 'FAQ', href: '/docs/faq', icon: MessageCircleQuestion },
];
